import { appEnv } from "./tenant";

class Util {

    constructor() {
    }

    combineUrl(parent,child){

        if (!child){
            return parent;
        }
        let rootpath   = (parent.slice(-1) == "/") ? parent : parent + "/";
        let appendpath = (child.slice(0,1) == "/") ? child.slice(1) : child;
        return rootpath + appendpath;
    }

    // companyCdを付与したAPIパスを生成する
    buildApiPath(path){
        if (!path) return path;

        let p = path;
        if (p.startsWith("/api/")) {
            p = p.slice(4);
        } else if (p === "/api") {
            p = "";
        }

        if (!p.startsWith("/")) {
            p = "/" + p;
        }

        // 会社コードはアクセスしたホスト名から判定する（SPEC-039）
        const companyCd = appEnv.VUE_APP_COMPANY_CD;
        if (!companyCd) {
            return p;
        }

        return "/" + companyCd + p;
    }

    // パラメータ付きURLを生成する
    // path
    // paramMap パラメータのマップ ( name:value の形式)
    buildParamUrl(path,paramMap){

        let params = [];
        if (paramMap){
            for (let key in paramMap) {
                if (paramMap.hasOwnProperty(key)){
                    let v = paramMap[key];
                    if (v !== null && v !== undefined){
                        params.push("" + key + "=" + encodeURI(v))
                    }
                }
            }
        }


        let result = path;

        for (let i = 0; i < params.length; i++) {

            if (i === 0){
                result += "?" + params[i];
            } else {
                result += "&" + params[i];
            }
        }

        return result;
    }

    checkEnvFlag(v, defaultValue) {
        if (defaultValue === undefined) {
            defaultValue = false;
        }

        if (v === null || v === undefined) {
            return defaultValue;
        } else return !!Number(v);
    }

    // スネークケースをキャメルケースへ変換する
    toCamelCase(str) {
        return str.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
    }

    // オブジェクト/配列のキーをキャメルケースへ変換する
    toCamelCaseDeep(value) {
        if (Array.isArray(value)) {
            return value.map(v => this.toCamelCaseDeep(v));
        }
        if (value && typeof value === "object") {
            const result = {};
            Object.keys(value).forEach(key => {
                const nextKey = this.toCamelCase(key);
                result[nextKey] = this.toCamelCaseDeep(value[key]);
            });
            return result;
        }
        return value;
    }

    // キャメルケースをスネークケースへ変換する
    toSnakeCase(str) {
        return str.replace(/[A-Z]/g, (c) => "_" + c.toLowerCase());
    }

    // キャメルケースに変換済みのオブジェクトへスネークケースの別名を付与する
    addSnakeCaseAliasesDeep(value) {
        if (Array.isArray(value)) {
            return value.map(v => this.addSnakeCaseAliasesDeep(v));
        }
        if (value && typeof value === "object") {
            const result = {};
            Object.keys(value).forEach(key => {
                const nextValue = this.addSnakeCaseAliasesDeep(value[key]);
                result[key] = nextValue;

                const snakeKey = this.toSnakeCase(key);
                if (!(snakeKey in result)) {
                    result[snakeKey] = nextValue;
                }
            });
            return result;
        }
        return value;
    }
}

let _util = new Util();

export default _util;
